import { render, staticRenderFns } from "./UgTableCell.vue?vue&type=template&id=f31bc632&scoped=true"
import script from "./UgTableCell.vue?vue&type=script&lang=ts"
export * from "./UgTableCell.vue?vue&type=script&lang=ts"
import style0 from "./UgTableCell.vue?vue&type=style&index=0&id=f31bc632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31bc632",
  null
  
)

export default component.exports